module.exports = __webpack_public_path__ + "img/bg.65790276.jpg";